<template>
  <v-dialog
    width="90%"
    max-width="1300px"
    v-model="showTripForm"
    persistent
    scrollable
  >
    <v-card v-if="showTripForm" class="elevation-8">
      <!-- Enhanced Header Design -->
      <v-card-title
        class="primary white--text px-6 py-4 d-flex justify-space-between"
      >
        <div class="d-flex flex-column flex-md-row align-center w-100">
          <!-- Trip ID and Status Section -->
          <div class="d-flex align-center flex-wrap">
            <v-icon large class="mr-3">mdi-truck-outline</v-icon>
            <div class="mr-4">
              <h2 class="text-h5 mb-1" v-if="leg && leg.leg_id">
                {{ leg.leg_id }}
              </h2>
              <v-chip
                v-if="leg && leg.da_movement_date_time"
                color="accent"
                text-color="white"
                small
                class="mt-1"
              >
                <v-icon left small>mdi-calendar-clock</v-icon>
                {{ leg.da_movement_date_time | formatDate(true) }}
              </v-chip>
            </div>
          </div>
          <!-- Payment Warning Alert -->
          <!-- <v-chip
            v-if="
              leg.payment_terms === 'P01' && leg.payment_method === 'Credit'
            "
            color="white"
            text-color="warning"
            small
            class="ml-3"
          >
            <v-icon left small color="warning">mdi-alert</v-icon>
            Credit customer marked as COD
          </v-chip> -->
          <v-spacer class="d-none d-md-flex"></v-spacer>

          <!-- Actions Section with Route Menu -->
          <div class="d-flex align-center mt-2 mt-md-0">
            <!-- Enhanced Route Address Menu -->
            <v-menu open-on-hover right offset-y v-if="leg" max-width="500">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon color="white" v-on="on" v-bind="attrs">
                  <v-icon>mdi-map-marker-distance</v-icon>
                </v-btn>
              </template>

              <!-- Enhanced Route Address Card -->
              <v-card class="elevation-8">
                <v-card-title class="info white--text py-3">
                  <v-icon left>mdi-map-marker-path</v-icon>
                  Route Address Details
                </v-card-title>
                <v-card-text class="pa-4">
                  <div class="route-details">
                    <!-- Source Address -->
                    <div v-if="leg.source_address" class="address-item mb-4">
                      <div class="d-flex align-center mb-2">
                        <v-avatar size="32" color="success" class="mr-3">
                          <v-icon color="white" small>mdi-map-marker</v-icon>
                        </v-avatar>
                        <div>
                          <div class="font-weight-medium text-subtitle-2">
                            Source Address
                          </div>
                          <div class="text-caption text--secondary">
                            Starting Point
                          </div>
                        </div>
                      </div>
                      <div class="address-text ml-11">
                        {{ leg.source_address }}
                      </div>
                    </div>

                    <!-- Mid Address -->
                    <div v-if="leg.mid_address" class="address-item mb-4">
                      <div class="d-flex align-center mb-2">
                        <v-avatar size="32" color="warning" class="mr-3">
                          <v-icon color="white" small
                            >mdi-map-marker-radius</v-icon
                          >
                        </v-avatar>
                        <div>
                          <div class="font-weight-medium text-subtitle-2">
                            Mid Point Address
                          </div>
                          <div class="text-caption text--secondary">
                            Intermediate Stop
                          </div>
                        </div>
                      </div>
                      <div class="address-text ml-11">
                        {{ leg.mid_address }}
                      </div>
                    </div>

                    <!-- Destination Address -->
                    <div v-if="leg.destination_address" class="address-item">
                      <div class="d-flex align-center mb-2">
                        <v-avatar size="32" color="error" class="mr-3">
                          <v-icon color="white" small
                            >mdi-flag-checkered</v-icon
                          >
                        </v-avatar>
                        <div>
                          <div class="font-weight-medium text-subtitle-2">
                            Destination Address
                          </div>
                          <div class="text-caption text--secondary">
                            Final Destination
                          </div>
                        </div>
                      </div>
                      <div class="address-text ml-11">
                        {{ leg.destination_address }}
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-menu>
          </div>
        </div>

        <div class="ml-auto">
          <v-btn icon color="white" @click="handleClose()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-row>
      <v-col cols="12" class="mt-2">
    <v-alert
           v-if="
              leg.payment_terms === 'P01' && leg.payment_method === 'Credit'
            "
      border="bottom"
      color="info"
      dark
    >
          Credit customer marked as COD
    </v-alert>
        </v-col>

      </v-row>

      <v-card-text class="pa-6">
        <v-row class="my-0">
          <FormComponent
            :nonFieldErrors="formErrors.non_field_errors"
            :title="`Asset Allocation ${
              formDetails.trip_id ? '#' + formDetails.trip_id : ''
            }`"
            :stickyHeader="true"
          >
            <template #formActions>
              <v-btn
                color="warning"
                outlined
                :disabled="(formDetails && !formDetails.id) || isTripActive"
                @click="deleteLegTrip()"
                class="mr-3"
              >
                <v-icon left small>mdi-truck-remove</v-icon>
                UnAllocate
              </v-btn>
              <v-btn
                color="primary"
                :disabled="!isValid"
                @click="submitForm"
                class="px-6"
              >
                <v-icon left small>mdi-check</v-icon>
                Submit
              </v-btn>
            </template>

            <template #formContent>
              <v-form ref="adminTripForm" v-model="isValid">
                <v-row class="ma-0">
                  <!-- Container Selection Section -->
                  <v-col cols="12" lg="3" class="Form-Columns-Dense">
                    <v-card outlined class="pa-4 form-section-card">
                      <div class="section-header mb-3">
                        <v-icon color="primary" class="mr-2"
                          >mdi-package-variant</v-icon
                        >
                        <span class="text-subtitle-1 font-weight-medium"
                          >Container Selection</span
                        >
                      </div>
                      <MultiSelect
                        :hideSelectAll="true"
                        hide-details="auto"
                        label="Select Containers *"
                        :showAll="true"
                        :readonly="isTripActive"
                        :items="leg.order_containers"
                        itemText="container_no"
                        itemValue="id"
                        :multiple="true"
                        :chips="true"
                        :rules="[
                          (val) => !!val || 'Containers is required',
                          (val) =>
                            !!(Array.isArray(val) && val.length) ||
                            'Containers is required',
                        ]"
                        v-model="formDetails.leg_containers"
                        :error-messages="formErrors.leg_containers"
                        @change="delete formErrors.leg_containers"
                      />
                    </v-card>
                  </v-col>
                  <v-col cols="12" lg="3" class="Form-Columns-Dense">
                    <v-card outlined class="pa-4 form-section-card">
                      <div class="section-header mb-3">
                        <v-icon color="primary" class="mr-2"
                          >mdi-timer-sand</v-icon
                        >
                        <span class="text-subtitle-1 font-weight-medium"
                          >Buffer Time(In Mins)</span
                        >
                      </div>
                      <InputField
                        :key="formDetails.buffer_time"
                        type="number"
                        label="Buffer Time(In Mins) *"
                        :rules="[(val) => !!val || 'Buffer Time is Required!']"
                        required
                        hide-details="auto"
                        v-model="formDetails.buffer_time"
                      />
                    </v-card>
                  </v-col>

                  <!-- Trip Date Section -->
                  <v-col cols="12" lg="3" class="Form-Columns-Dense">
                    <v-card outlined class="pa-3 form-section-card">
                      <div class="section-header mb-2">
                        <v-icon color="primary" class="mr-2"
                          >mdi-calendar-clock</v-icon
                        >
                        <span class="text-subtitle-1 font-weight-medium"
                          >Trip Schedule</span
                        >
                      </div>
                      <DateField
                        ref="TripDateField"
                        :inputProps="{
                          dense: false,
                          label: 'Trip Date *',
                          rules: [(val) => !!val || 'Trip Date is Required!'],
                          'hide-details': 'auto',
                          'error-messages': formErrors.trip_date,
                          disabled: isTripActive,
                        }"
                        :min="today"
                        v-model="formDetails.trip_date"
                        @change="
                          delete formErrors.trip_date;
                          refreshFormDetails();
                          checkAssetType();
                        "
                      />
                    </v-card>
                  </v-col>
                  <v-col cols="12" lg="3" class="Form-Columns-Dense">
                    <v-card outlined class="pa-3 form-section-card">
                      <div class="section-header mb-5">
                        <v-icon color="primary" class="mr-2">mdi-flag</v-icon>
                        <span class="text-subtitle-1 font-weight-medium"
                          >Milestone Template</span
                        >
                      </div>
                      <MultiSelect
                        label="Select Milestones Template"
                        :items="allMilestoneTemplateList"
                        itemText="name"
                        itemValue="id"
                        :chips="true"
                        hide-details="auto"
                        v-model="formDetails.milestone_template"
                        :rules="[
                          (val) => !!val || 'Milestone Template  is Required!',
                        ]"
                        :error-messages="formErrors.milestone_template"
                        @change="delete formErrors.milestone_template"
                      >
                      </MultiSelect>
                    </v-card>
                  </v-col>

                  <v-col cols="6" lg="6" class="Form-Columns-Dense">
                    <v-card outlined class="pa-2 form-section-card">
                      <div class="section-header mb-2">
                        <v-icon color="primary" class="mr-2"
                          >mdi-calendar-clock</v-icon
                        >
                        <span class="text-subtitle-1 font-weight-medium"
                          >Est. Start Date</span
                        >
                      </div>

                      <v-row>
                        <v-col cols="12" md="6" class="Form-Columns-Dense">
                          <DateField
                            :key="formDetails.est_start_date"
                            :inputProps="{
                              dense: true,
                              label: 'Est. Start Date*',
                              rules: [
                                (val) =>
                                  !!val || 'Est. Start Date is Required!',
                              ],

                              'hide-details': 'auto',
                            }"
                            :min="formDetails.trip_date"
                            required
                            v-model="formDetails.est_start_date"
                            @change="updateEstEndDate"
                          />
                        </v-col>

                        <v-col cols="12" md="6" class="Form-Columns-Dense">
                          <InputField
                            :key="formDetails.est_start_time"
                            type="time"
                            label="Est.Start Time *"
                            :rules="[
                              (val) => !!val || 'Est. Start  Time is Required!',
                            ]"
                            required
                            hide-details="auto"
                            v-model="formDetails.est_start_time"
                            @input="updateEstEndDate"
                          />
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>

                  <v-col cols="6" lg="6" class="Form-Columns-Dense">
                    <v-card outlined class="pa-2 form-section-card">
                      <div class="section-header mb-2">
                        <v-icon color="primary" class="mr-2"
                          >mdi-calendar-clock</v-icon
                        >
                        <span class="text-subtitle-1 font-weight-medium"
                          >Est. End Date</span
                        >
                      </div>

                      <v-row>
                        <v-col cols="12" md="6" class="Form-Columns-Dense">
                          <DateField
                            ref="EstEndDateField"
                            :key="formDetails.est_end_date"
                            :inputProps="{
                              dense: true,
                              label: 'Est. End Date *',
                              rules: [
                                (val) => !!val || 'Est. End Date is Required!',
                              ],
                              'hide-details': 'auto',
                            }"
                            :min="formDetails.est_start_date"
                            required
                            v-model="formDetails.est_end_date"
                          />
                        </v-col>

                        <v-col cols="12" md="6" class="Form-Columns-Dense">
                          <InputField
                            :key="formDetails.est_end_time"
                            type="time"
                            label="Est.End Time *"
                            :rules="[
                              (val) => !!val || 'Est. End  Time is Required!',
                            ]"
                            required
                            hide-details="auto"
                            v-model="formDetails.est_end_time"
                          />
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>

                  <!-- Asset Allocation Section -->
                  <v-col cols="12">
                    <v-card outlined class="pa-4 form-section-card">
                      <div
                        class="section-header mb-4 d-flex justify-space-between align-center"
                      >
                        <div class="d-flex align-center">
                          <v-icon color="primary" class="mr-2"
                            >mdi-truck-delivery</v-icon
                          >
                          <span class="text-subtitle-1 font-weight-medium"
                            >Asset Allocation</span
                          >
                        </div>

                        <!-- <v-chip class="ma-2" color="#FFAA33" outlined style="cursor: pointer;"
                          @click="filterIdleDrivers">
                          <v-icon left>mdi-check</v-icon>
                          Select Available Drivers
                        </v-chip> -->
                      </div>

                      <v-row>
                        <!-- Enhanced Driver Selection -->
                        <v-col cols="12" lg="3" class="Form-Columns-Dense">
                          <div class="input-wrapper">
                            <div class="input-label mb-2">
                              <v-icon small color="grey darken-1" class="mr-1"
                                >mdi-account</v-icon
                              >
                              Driver Assignment
                            </div>
                            <MultiSelect
                              label="Select Driver *"
                              :items="driverList"
                              :showDriverChips="true"
                              itemText="driver_name"
                              itemValue="id"
                              v-model="formDetails.driver"
                              @change="
                                delete formErrors.driver;
                                vehicleAssigned();
                              "
                            >
                            </MultiSelect>
                          </div>
                        </v-col>

                        <!-- Enhanced Vehicle Selection -->
                        <v-col cols="12" lg="3" class="Form-Columns-Dense">
                          <div class="input-wrapper">
                            <div class="input-label mb-2">
                              <v-icon small color="grey darken-1" class="mr-1"
                                >mdi-truck</v-icon
                              >
                              Vehicle Assignment
                            </div>

                            <MultiSelect
                              label="Select Vehicle *"
                              :items="vehicleList"
                              itemText="inventory_number"
                              itemValue="id"
                              :disabled="!formDetails.trip_date"
                              :rules="[(val) => !!val || 'Vehicle is required']"
                              hide-details="auto"
                              v-model="formDetails.vehicle"
                              :error-messages="formErrors.vehicle"
                              @change="delete formErrors.vehicle"
                            >
                            </MultiSelect>
                          </div>
                        </v-col>

                        <!-- Enhanced Trailer 1 Selection -->
                        <v-col cols="12" lg="3" class="Form-Columns-Dense">
                          <div class="input-wrapper">
                            <div class="input-label mb-2">
                              <v-icon small color="grey darken-1" class="mr-1"
                                >mdi-truck-trailer</v-icon
                              >
                              Primary Trailer
                            </div>
                            <MultiSelect
                              label="Select Trailer 1*"
                              :items="trailer1List"
                              itemText="inventory_number"
                              itemValue="id"
                              :disabled="!formDetails.trip_date"
                              :rules="[
                                (val) => !!val || 'Trailer 1 is required',
                              ]"
                              hide-details="auto"
                              v-model="formDetails.trailer_1"
                              :error-messages="formErrors.trailer_1"
                              @change="delete formErrors.trailer_1"
                            >
                            </MultiSelect>
                          </div>
                        </v-col>

                        <!-- Enhanced Trailer 2 Selection -->
                        <v-col cols="12" lg="3" class="Form-Columns-Dense">
                          <div class="input-wrapper">
                            <div class="input-label mb-2">
                              <v-icon small color="grey darken-1" class="mr-1"
                                >mdi-truck-trailer</v-icon
                              >
                              Secondary Trailer
                            </div>
                            <MultiSelect
                              label="Select Trailer 2 (Optional)"
                              :items="trailer2List"
                              itemText="inventory_number"
                              itemValue="id"
                              :item-disabled="
                                (item) => {
                                  return item.id == formDetails.trailer_1;
                                }
                              "
                              :clearable="true"
                              :disabled="
                                !formDetails.trip_date || !formDetails.trailer_1
                              "
                              hide-details="auto"
                              v-model="formDetails.trailer_2"
                              :error-messages="formErrors.trailer_2"
                              @change="delete formErrors.trailer_2"
                            >
                            </MultiSelect>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>

                  <!-- Enhanced Trip Tags Display -->
                  <v-col
                    cols="12"
                    v-if="
                      formDetails.trip_tags && formDetails.trip_tags.length > 0
                    "
                  >
                    <v-card outlined class="pa-4 form-section-card">
                      <div class="section-header mb-3">
                        <v-icon color="primary" class="mr-2"
                          >mdi-tag-multiple</v-icon
                        >
                        <span class="text-subtitle-1 font-weight-medium"
                          >Trip Tags</span
                        >
                      </div>
                      <div class="d-flex flex-wrap">
                        <v-chip
                          v-for="(tag, i) in formDetails.trip_tags"
                          :key="i"
                          class="ma-1"
                          color="primary"
                          outlined
                          small
                        >
                          <v-icon left x-small>mdi-label</v-icon>
                          {{ tag.tag_name }}
                        </v-chip>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-form>
            </template>
          </FormComponent>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Contract Details Dialog (unchanged) -->
    <v-dialog v-model="viewSelectedContract" width="70%">
      <v-card
        v-if="displayingContract && Object.keys(displayingContract).length > 0"
      >
        <v-card-title class="secondary white--text">
          {{ displayingContract.contract_id }} Details
          <v-spacer></v-spacer>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="white"
                icon
                @click="viewSelectedContract = false"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Close</span>
          </v-tooltip>
        </v-card-title>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import ContainerCard from "@/components/General/ContainerCard.vue";
import FormComponent from "@/components/General/FormComponent.vue";
import DateField from "@/components/FormBaseComponents/DateField.vue";

export default {
  components: {
    InputField,
    MultiSelect,
    ContainerCard,
    FormComponent,
    DateField,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    legId: {
      required: true,
      default: () => {},
    },

    legDetails: {
      required: true,
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isTripActive: false,
      allMilestoneTemplateList: [],

      checked: false,
      today: new Date().toISOString().slice(0, 16),

      isValid: true,
      isAssignmentFormValid: true,

      leg: {},
      formErrors: {},
      formDetails: {
        tags: [],
        auto_assign_driver: true,
        est_start_date: null,
        est_end_date: null,
        est_end_time: null,
        est_start_time: null,
        buffer_time: 30,
      },
      routeDuration: null,

      trailer1List: [],
      trailer2List: [],
      vehicleList: [],
      driverList: [],

      displayingContract: {},
      viewSelectedContract: false,
      getListCalled: false,
    };
  },
  watch: {
    value(val) {
      if (val) {
        // Reset the flag when dialog opens

        this.getListCalled = false;
        this.getLegListObject(this.legId);
        this.getMilestoneTemplateLists();
      } else {
        this.isTripActive = false;
        this.formDetails = {};
        this.getListCalled = false;
      }
    },
  },

  computed: {
    showTripForm: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    currentProfile() {
      let obj = localStorage.getItem("userProfile");
      return !obj ? obj : JSON.parse(obj);
    },
  },
  methods: {
    updateEstEndDate() {
      const { est_start_date, est_start_time } = this.formDetails;
      const duration = this.legDetails?.lane_duration || 0;
      const buffer = this.formDetails?.buffer_time || 0;

      if (!est_start_date || !est_start_time) {
        this.formDetails.est_end_date = null;
        this.formDetails.est_end_time = null;
        return;
      }

      const startDateTime = new Date(`${est_start_date}T${est_start_time}`);
      if (isNaN(startDateTime.getTime())) {
        this.formDetails.est_end_date = null;
        this.formDetails.est_end_time = null;
        return;
      }

      // Add duration in minutes
      const endDateTime = new Date(
        startDateTime.getTime() + (duration + buffer * 2) * 60 * 1000
      );

      // Format date in local timezone
      const pad = (n) => (n < 10 ? "0" + n : n);

      this.$set(
        this.formDetails,
        "est_end_date",
        `${endDateTime.getFullYear()}-${pad(endDateTime.getMonth() + 1)}-${pad(
          endDateTime.getDate()
        )}`
      );
      this.$set(
        this.formDetails,
        "est_end_time",
        `${pad(endDateTime.getHours())}:${pad(endDateTime.getMinutes())}`
      );

      this.$nextTick(() => {
        const endDateField = this.$refs.EstEndDateField;
        if (endDateField && endDateField.setDefaultDateTime) {
          endDateField.setDefaultDateTime();
        }

        this.$forceUpdate();
      });

      if (
        this.formDetails.est_end_date &&
        this.formDetails.est_end_time &&
        this.formDetails.trip_date
      ) {
        if (!this.getListCalled) {
          this.getListCalled = true;
          this.getLists().catch((err) => {
            console.error("Error calling getLists:", err);
          });
        }
      }
    },

    getDriverStatusColor(status) {
      switch (status) {
        case "Active":
          return "green";
        case "Inactive":
          return "grey";
        case "Leave":
        case "On Leave":
          return "orange";
        case "Deactivated":
        case "Detached":
          return "red";
        case "Idle":
          return "blue";
        case "On Trip":
          return "purple";
        default:
          return "grey";
      }
    },
    getMilestoneTemplateLists(params = {}) {
      this.$bus.$emit("showLoader", true);
      params = {
        limit: "all",
      };
      this.$api.milestoneTemplate
        .getMilestoneTemplateList(params)
        .then((res) => {
          this.allMilestoneTemplateList = res.data;
          this.totalItems = res.count;
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },

    async getLegListObject(id) {
      this.$bus.$emit("showLoader", true);
      this.$api.trip
        .getLegDataforAssetAllocation(id)
        .then(async (res) => {
          this.$bus.$emit("showLoader", false);
          this.leg = res.data;

          await this.getAllocatedAssets();

          if (
            this.leg &&
            this.leg.trip_status &&
            [
              "Enroute",
              "Reached Pickup Location",
              "Reached Drop Location",
            ].indexOf(this.leg.trip_status) > -1
          ) {
            this.isTripActive = true;
          } else {
            this.isTripActive = false;
          }
          this.formDetails.milestone_template = res.data.milestone_template;
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
    refreshFormDetails() {
      this.formDetails = { ...this.formDetails };
    },
    deleteLegTrip() {
      if (confirm("Are you sure you want to unallocate ?")) {
        this.$bus.$emit("showLoader", true);
        this.$api.trip
          .deleteLegTrip(this.leg.id)
          .then(() => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Leg's trip deleted successfully!",
              color: "success",
            });
            this.resetForm();
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Couldn't delete leg's trip!",
              color: "error",
            });
          });
      }
    },
    vehicleAssigned() {
      let assignedVehicle = this.driverList.find(
        (dri) => dri.id == this.formDetails.driver
      )?.assigned_vehicle;
      let vehicleExist = this.vehicleList.find(
        (obj) => obj.id == assignedVehicle
      );
      if (vehicleExist) {
        this.formDetails = {
          ...this.formDetails,
          vehicle: assignedVehicle,
        };
      }
    },
    getLists() {
      this.$bus.$emit("showLoader", true);
      return new Promise((resolve, reject) => {
        Promise.all([
          this.getAssetList("Trailer"),
          this.getAssetList("Driver"),
          this.getAssetList("Vehicle"),
        ])
          .then((val) => {
            this.getListCalled = false;
            this.$bus.$emit("showLoader", false);
            resolve();
          })
          .catch((err) => {
            this.getListCalled = false;
            this.$bus.$emit("showLoader", false);
            reject();
          });
      });
    },
    handleClose() {
      this.$emit("closeTripForm");
      this.resetForm();
      this.formErrors = {};
    },

    resetForm() {
      this.formDetails = {};
      (this.trailer1List = []),
        (this.trailer2List = []),
        (this.vehicleList = []),
        (this.driverList = []),
        (this.showTripForm = false);
      this.resetFormValidation();
    },
    resetFormValidation() {
      let form = this.$refs.adminTripForm;
      if (form) {
        form.resetValidation();
      }
    },
    isDriverAvailable(status) {
      return status === "Idle";
    },

    filterIdleDrivers() {
      if (!this.originalDriverList) {
        this.originalDriverList = [...this.driverList];
      }

      this.driverList = this.originalDriverList.filter((driver) =>
        this.isDriverAvailable(driver.status)
      );
    },

    checkAssetType() {
      this.formDetails.trailer_1 = null;
      this.formDetails.trailer_2 = null;
      this.formDetails.vehicle = null;
      this.formDetails.driver = null;
      this.resetFormValidation();
      // if (this.formDetails.trip_date) {
      //   if (!this.getListCalled) {
      //     this.getListCalled = true;
      //     this.getLists();
      //   }
      // }
    },

    async getAssetList(assetType) {
      const params = {
        ...params,
        asset_type: assetType,
        trip_date: this.formDetails.trip_date,
        leg: this.leg.id,
        est_start_date: this.formDetails.est_start_date,
        est_start_time: this.formDetails.est_start_time,
        est_end_date: this.formDetails.est_end_date,
        est_end_time: this.formDetails.est_end_time,

        tagIds:
          this.formDetails.tags &&
          Array.isArray(this.formDetails.tags) &&
          this.formDetails.tags.length > 0
            ? [...this.formDetails.tags].join()
            : null,
      };

      if (this.currentProfile && this.currentProfile.company) {
        params.company = this.currentProfile.company;
      }

      if (this.formDetails.id) {
        params.trip = this.formDetails.id;
      }

      return this.$api.trip
        .getTripAssetList(this.legId, params)
        .then((res) => {
          if (assetType == "Trailer") {
            this.trailer1List = res.data.trailer1;
            this.trailer2List = res.data.trailer2;
          }
          if (assetType == "Vehicle") {
            this.vehicleList = res.data;
          }
          if (assetType == "Driver") {
            this.driverList = res.data;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    async getAllocatedAssets() {
      this.$api.trip
        .getAllocatedAssets({ leg: this.leg.id })
        .then((res) => {
          this.formDetails = {
            tags: [],
            ...this.formDetails,
            ...res.data,
            leg: this.leg.id,
          };
          if (this.formDetails.duration) {
            this.routeDuration = this.formDetails.duration;
          }
          if (this.formDetails.trip_date) {
            this.formDetails.trip_date = res.data.trip_date.replace(" ", "T");
          } else {
            this.formDetails.trip_date = this.leg.da_movement_date_time.slice(
              0,
              10
            );
          }
          setTimeout(() => {
            const field = this.$refs.TripDateField;
            if (field) {
              field.setDefaultDateTime();
            }
          }, 20);

          if (
            this.leg &&
            this.leg.order_containers &&
            this.leg.order_containers.length > 0
          ) {
            this.formDetails.leg_containers = this.leg.order_containers.map(
              (item) => item.id
            );
          }

          if (
            this.formDetails.trip_date &&
            this.legDetails.status !== "Created"
          ) {
            this.formDetails.est_start_date = this.legDetails.est_start_date;
            this.formDetails.est_start_time = this.legDetails.est_start_time;
            this.formDetails.est_end_date = this.legDetails.est_end_date;
            this.formDetails.est_end_time = this.legDetails.est_end_time;
            if (!this.getListCalled) {
              this.getListCalled = true;
              this.getLists()
                .then(() => {
                  this.formDetails.vehicle = res.data.vehicle;
                  this.formDetails.trailer_1 = res.data.trailer_1;
                  this.formDetails.trailer_2 = res.data.trailer_2;
                  this.formDetails.driver = res.data.driver;
                })
                .catch((err) => {
                  console.error(err);
                });
            }
          }

          this.$forceUpdate();
          this.resetFormValidation();
        })
        .catch((err) => {
          console.error(err);
        });
    },

    submitForm() {
      let payload = {
        ...this.formDetails,
        depot: this.legDetails.depot,
      };
      this.$api.trip
        .updateAllocatedAssets(payload)
        .then((res) => {
          this.showTripForm = false;
          this.$emit("refreshList");
          this.$bus.$emit("showToastMessage", {
            message: "Assets updated successfully!",
            color: "success",
          });
        })
        .catch((err) => {
          this.formErrors = err.data;
        });
    },
  },
  beforeDestroy() {
    this.resetFormValidation();
  },
};
</script>

<style scoped>
/* Enhanced Design Styles */
.route-chip {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  transition: all 0.3s ease;
}

.route-chip:hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
  transform: translateY(-1px);
}

.form-section-card {
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
}

.form-section-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12) !important;
  border-color: rgba(25, 118, 210, 0.3) !important;
}

.section-header {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.87);
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding-bottom: 8px;
}

.input-wrapper {
  position: relative;
}

.input-label {
  display: flex;
  align-items: center;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: rgba(0, 0, 0, 0.6);
}

.route-details {
  max-width: 450px;
}

.address-item {
  padding: 12px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.address-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.address-text {
  background-color: rgba(0, 0, 0, 0.04);
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 0.875rem;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.87);
}

.v-list-item:hover {
  background-color: rgba(25, 118, 210, 0.08) !important;
}

.v-list-item-avatar .v-avatar {
  transition: all 0.3s ease;
}

.v-list-item:hover .v-list-item-avatar .v-avatar {
  transform: scale(1.1);
}

.v-btn {
  transition: all 0.3s ease;
}

.v-btn:hover {
  transform: translateY(-1px);
}

.v-chip {
  transition: all 0.3s ease;
}

.v-chip:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.v-dialog > .v-card {
  border-radius: 8px !important;
}

.v-card-title {
  border-radius: 8px 8px 0 0 !important;
}

.Form-Columns-Dense {
  padding: 8px !important;
}

@media (max-width: 960px) {
  .route-chip {
    margin: 2px 0;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .input-label {
    font-size: 0.7rem;
  }
}
</style>
